(() => {
if (customElements.get('crafii-search-shell')) return;

class CrafiiSearchShell extends HTMLElement {
  connectedCallback() {
    this.searchInput = this.querySelector('input[type="search"]');
    this.searchDetails = this.closest('details');
    this.updateQueryState = () => {
      this.toggleAttribute('data-has-query', Boolean(this.searchInput?.value.trim()));
    };
    this.updatePosition = () => {
      if (!this.searchDetails?.open) return;
      const announcement = document.querySelector('.crafii-studio-announcement');
      const top = Math.max(0, announcement?.getBoundingClientRect().bottom || 0);
      this.style.setProperty('--cf-search-top', `${top}px`);
    };
    this.onReset = () => requestAnimationFrame(this.updateQueryState);
    this.resetControl = this.querySelector('button[type="reset"]');
    this.onClear = () => {
      this.querySelector('[aria-selected="true"]')?.setAttribute('aria-selected', 'false');
      this.searchInput?.removeAttribute('aria-activedescendant');
    };
    this.onToggle = () => {
      this.updatePosition();
      this.updateQueryState();
    };
    this.searchInput?.addEventListener('input', this.updateQueryState);
    this.searchInput?.form?.addEventListener('reset', this.onReset);
    this.resetControl?.addEventListener('click', this.onClear);
    this.searchDetails?.addEventListener('toggle', this.onToggle);
    window.addEventListener('resize', this.updatePosition);
    this.updateQueryState();
  }

  disconnectedCallback() {
    this.searchInput?.removeEventListener('input', this.updateQueryState);
    this.searchInput?.form?.removeEventListener('reset', this.onReset);
    this.resetControl?.removeEventListener('click', this.onClear);
    this.searchDetails?.removeEventListener('toggle', this.onToggle);
    window.removeEventListener('resize', this.updatePosition);
  }
}

customElements.define('crafii-search-shell', CrafiiSearchShell);
})();
